import { Link, Outlet, useLocation } from 'react-router-dom';
import { usePageAnalytics } from '../../hooks/usePageAnalytics';
import { signOut, useAuthState } from '../../lib/partnerAuth';
import { SupportStrip } from './SupportStrip';
import { PayoutMinimumBanner } from './PayoutMinimumBanner';
import styles from './PartnerLayout.module.css';
import logo from '../../assets/images/logo.png';

const navLinks = [
  { label: 'Dashboard', href: '/partners/dashboard' },
  { label: 'Campaigns', href: '/partners/campaigns' },
  { label: 'Earnings', href: '/partners/earnings' },
  { label: 'How to Use', href: '/partners/faq' },
];

export function PartnerLayout() {
  usePageAnalytics();
  const location = useLocation();
  const { isAdmin } = useAuthState();
  const showPayoutBanner = !location.pathname.startsWith('/partners/admin');

  const allNavLinks = isAdmin
    ? [...navLinks, { label: 'Admin', href: '/partners/admin' }]
    : navLinks;

  return (
    <div className={styles.layout}>
      <nav className={styles.nav}>
        <Link to="/partners/dashboard" className={styles.logo}>
          <img src={logo} alt="" width={28} height={28} />
          <span className={styles.brand}>LuvLust Partners</span>
        </Link>
        <div className={styles.links}>
          {allNavLinks.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              className={`${styles.navLink} ${location.pathname === l.href ? styles.active : ''}`}
            >
              {l.label === 'Admin' ? (
                <>
                  <span className={styles.navLinkText}>{l.label}</span>
                  <span className={styles.adminTag}>Admin</span>
                </>
              ) : (
                l.label
              )}
            </Link>
          ))}
        </div>
        <button className={styles.logout} onClick={() => signOut()}>
          Sign Out
        </button>
      </nav>
      <main className={styles.main}>
        {showPayoutBanner ? <PayoutMinimumBanner /> : null}
        <Outlet />
      </main>
      <SupportStrip />
    </div>
  );
}
